import { v4 as uuidv4 } from 'uuid';
import ScanBoxGismtView from './ScanBoxGismtView'
import { ScanBoxGismtCreatePluginSettings } from './ScanBoxGismtCreatePluginSettings';

export const ScanBoxGismtTabTitle = "Короб ГИС МТ";

export const ScanBoxGismtTab = (): ITab => {
    return {
        id: uuidv4(),
        title: ScanBoxGismtTabTitle,
        view: {
            content: ScanBoxGismtCreatePluginSettings
                ? <ScanBoxGismtView gridId={uuidv4()} plugin={ScanBoxGismtCreatePluginSettings} />
                : <p> Справочник не настроен </p>
        }
    }
}

export default ScanBoxGismtTab